import { Model } from "../Model"

export const useModel = () => {
    return Model.GetModel();
}
